import { createSelector } from 'reselect';

const getPayment = (state) => state.payment;

export const getPaymentErrors = (field) => createSelector(
  [getPayment],
  payment => payment.errors?.[field]
);
